import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { ConsoleRequest, DataProviderType } from '../../../utils/request';
import {
  GetDepartmentIdentitiesResponse,
  GetDepartmentsResponse,
  GetUserResourcesRecord,
  GetUserResourcesResponse,
  LOAD_LIMIT,
  PhasrBehavioralProfilesMethods,
  RequestPayload
} from '../types';

export class PhasrBehavioralProfilesComponentBaseDataProvider extends BaseWebComponentDataProvider {
  private endpoint = 'BehavioralProfiles';

  public async getDepartments(payload: RequestPayload): Promise<GetDepartmentsResponse> {
    return await ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.ENDPOINTS,
      endpoint: this.endpoint,
      method: PhasrBehavioralProfilesMethods.GET_DEPARTMENTS,
      payload: payload,
    });
  }

  public async getDepartmentIdentities(payload: RequestPayload): Promise<GetDepartmentIdentitiesResponse> {
    return await ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.ENDPOINTS,
      endpoint: this.endpoint,
      method: PhasrBehavioralProfilesMethods.GET_DEPARTMENT_USERS,
      payload: payload,
    });
  }

  public async getUserResources(payload: RequestPayload): Promise<GetUserResourcesRecord[]> {
    const response = (await ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.ENDPOINTS,
      endpoint: this.endpoint,
      method: PhasrBehavioralProfilesMethods.GET_USER_DEVICES,
      payload: payload,
    })) as GetUserResourcesResponse;

    return response.records.map((item: GetUserResourcesRecord) => ({
      ...item,
      behavioralProfileResource: item.userId + item.behavioralProfileResource,
    }));
  }
}
